import {observer} from 'mobx-react-lite'
import React from 'react'
import {DataObjectId} from 'yougile-model'
import {cn} from '@containers/html-utils'
import {useIdTask} from './use-id-tasks'

interface Props {
  className?: string
  taskId: DataObjectId
  highlighted?: boolean
}

export const IdTaskText = observer((props: Props) => {
  const {taskId, className, highlighted} = props
  const idTask = useIdTask(taskId)

  if (!taskId || !idTask) {
    return null
  }

  return (
    <div
      className={cn(
        'text-sm-regular',
        'before:content-["("]',
        'after:content-[")"]',
        highlighted ? 'text-action-default' : 'text-secondary',
        className
      )}
    >
      {idTask}
    </div>
  )
})
